export type RootLandingRoute = 'loading' | 'dashboard' | 'public';

type RootLandingState = {
  authLoading: boolean;
  isAuthenticated: boolean;
  hasPersistedSessionHint: boolean;
};

/**
 * Authenticated returning users keep a workspace splash until Auth0/JWT
 * hydration finishes, so marketing copy never flashes before /dashboard.
 * Anonymous first visits paint the public homepage immediately.
 */
export const resolveRootLandingRoute = ({
  authLoading,
  isAuthenticated,
  hasPersistedSessionHint,
}: RootLandingState): RootLandingRoute => {
  if (isAuthenticated) return 'dashboard';
  if (authLoading && hasPersistedSessionHint) return 'loading';
  return 'public';
};
